import React, { createContext, useContext, PropsWithChildren } from 'react';

/* Interfaces */
import { AnalyticsClient } from '../Client';
import { FirebaseAnalyticsHandler } from '../FirebaseAnalyticsHandler';
import { BIEventsAnalyticsHandler } from '../BIEventsAnalyticsHandler';

interface AnalyticsHandlersContent {
  client: AnalyticsClient;
}

export const AnalyticsHandlersContext =
  createContext<AnalyticsHandlersContent | null>(null);

export const AnalyticsHandlersProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const firebase = new FirebaseAnalyticsHandler();
  const BIEvent = new BIEventsAnalyticsHandler();

  const value = {
    client: new AnalyticsClient(firebase, BIEvent),
  };

  return (
    <AnalyticsHandlersContext.Provider value={value}>
      {children}
    </AnalyticsHandlersContext.Provider>
  );
};

export const useAnalyticsHandlers = () => useContext(AnalyticsHandlersContext);
